export default "/fonts/SofiaSans-400-Regular.woff2?f0d13e2ba7fba790b6ece70a26461f8c";